import React from 'react'
import BrandLayout from '../components/Layouts/BrandLayout'
import AuthorizationProviderContext from '../containers/AuthorizationProvider/AuthorizationProvider.context'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import OnboardingDialogContainer from '../containers/OnboardingDialog/OnboardingDialog.container'
import QuoteProvidersListContainer from '../containers/QuoteProvidersList/QuoteProvidersList.container'
import NotFoundPage from './NotFound'

/**
 * The QuoteProvidersList's page.
 */
const QuoteProvidersList = () => {
  return (
    <AuthorizationProviderContainer>
      <AuthorizationProviderContext.Consumer>
        {({ isBuyer }) =>
          isBuyer ? (
            <BrandLayout>
              <QuoteProvidersListContainer />
              <OnboardingDialogContainer />
            </BrandLayout>
          ) : (
            <NotFoundPage />
          )
        }
      </AuthorizationProviderContext.Consumer>
    </AuthorizationProviderContainer>
  )
}

export default QuoteProvidersList
